import { Injectable, OnDestroy, OnInit } from '@angular/core'
import { UserStore } from 'src/app/stores/user.store';

import { Subject, takeUntil, map } from 'rxjs';
import { Router } from '@angular/router'
import { User } from 'src/app/models/user';

// Funny name, this provider is actually a handler
@Injectable()
export class StateProvider implements OnInit, OnDestroy {

    ngUnsubscribeUser = new Subject();

    constructor(private userStore: UserStore,
                private router: Router) {

        this.userStore.state$
            .pipe(
                takeUntil(this.ngUnsubscribeUser),
                map((user: User) => {
                    const token = localStorage.getItem('token');
                    if (token == null || token == '') {
                        let redirectUrl = `?redirect=${location.pathname}`
                        if (location.pathname == '' || location.pathname == '/' || location.pathname == '/login') {
                            redirectUrl = ''
                        }
                        if (location.pathname == '/login') {
                            redirectUrl = location.search
                        }
                        this.router.navigateByUrl(`login${redirectUrl}`)
                    }
                })
            )
            .subscribe(data => {

            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribeUser.next(null);
        this.ngUnsubscribeUser.complete();
    }

    ngOnInit(): void {
        
    }
}
